<style lang="scss" scoped>
.approval-instance-warp {
  position: relative;

  .col-filter {
    padding: 8px;
    font-size: 16px;

    &:hover {
      color: #2f78ff;
    }

    &:active {
      opacity: 0.6;
    }
  }

  .el-tabs_right_panel {
    position: absolute;
    right: 0;
    top: 4px;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;

    &:hover {
      color: #2f78ff;
    }

    &:active {
      opacity: 0.6;
    }
  }
}
</style>
<template>
  <div class="approval-instance-warp">
    <el-tabs v-model="tabActiveId" @tab-click="tabChangeHandler">
      <el-tab-pane :label="typeItem.name" :name="`${typeItem.id}`"
        :key="typeItem.id" v-for="typeItem in approvalTypes"></el-tab-pane>
    </el-tabs>
    <div class="el-tabs_right_panel">
      <el-tooltip class="item" effect="dark" content="数据审查" placement="top"
        :open-delay="1000">
        <i class="el-icon-data-analysis"
          @click="$router.push('/approval/instance/review')"></i>
      </el-tooltip>
    </div>

    <az-panel>
      <template slot="lft">
        <el-button type="primary" size="medium"
          v-if="approvalTypes.constMap.idMap[tabActiveId] && approvalTypes.constMap.idMap[tabActiveId].name == '已发起'"
          @click="$refs['chooseApprovalBar'].$emit('open')">
          <i class="azappfont  az-app-create btn-lft-icon"></i>发起审批
        </el-button>
        <az-button
          v-if="approvalTypes.constMap.idMap[tabActiveId] && approvalTypes.constMap.idMap[tabActiveId].name == '已发起'"
          type="refresh" size="medium" :infoNotShow="true"
          @click.native="renderList"></az-button>
        <el-button v-else type="primary" icon="el-icon-refresh" size="medium"
          @click="renderList">刷新</el-button>
      </template>
      <template slot="rt">
        <az-button
          type="clear-url" size="medium" content="重置筛选项"
          @click.native="clearPageInfo"></az-button>
        <div class="block">
          选择类型
        </div>
        <el-select v-model="pageInfo.basic_type" placeholder="请选择审批类型" size="medium"
          filterable style="width: 170px;" @change="selectHandler">
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in approvalInstanceType"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <div class="block">
          选择状态
        </div>
        <el-select v-model="pageInfo.status" placeholder="请选择审批状态" size="medium"
          filterable style="width: 130px;" @change="selectHandler">
          <el-option
            v-for="item in statusList"
            :key="item.status"
            :label="item.name"
            :value="item.status">
          </el-option>
        </el-select>
        <div class="block" v-if="selectUserShow">
          筛选发起人
        </div>
        <el-select v-if="selectUserShow" v-model="pageInfo.user_open_id"
          placeholder="请搜索和选择" size="medium"
          filterable style="width: 130px;" @change="selectHandler">
          <el-option
            v-for="user in userList"
            :label="user.name"
            :key="user.open_id"
            :value="user.open_id">
          </el-option>
        </el-select>
        <az-search @search="searchHandler"
          ref="azSearch"
          placeholder="请输入标题，公司名称，发起人"
          :initValue="pageInfo.keyword">
        </az-search>

        <div class="col-filter">
          <el-popover placement="bottom" title="筛选列" trigger="click" width="40">
            <el-checkbox-group v-model="checkedColumns" size="mini">
              <el-checkbox v-for="item in checkBoxGroup" :key="item" :label="item"
                :value="item"></el-checkbox>
            </el-checkbox-group>
            <div title="筛选列" class="filter-table-col" slot="reference"><i
                class="el-icon-c-scale-to-original"></i></div>
          </el-popover>
        </div>
      </template>
    </az-panel>
    <el-table
      :key="reload"
      :data="tableList"
      size="small"
      style="width: 100%;">
      <el-table-column
        v-if="colData[0].istrue"
        prop="process_data.show_title"
        label="标题">
      </el-table-column>
      <el-table-column
        v-if="colData[1].istrue"
        width="150"
        prop="serial_number"
        label="记录编号">
      </el-table-column>
      <el-table-column
        v-if="colData[2].istrue"
        prop="promoter"
        label="发起人">
      </el-table-column>
      <el-table-column
        v-if="colData[3].istrue"
        prop="process_data.format_sum_money"
        label="金额">
      </el-table-column>
      <el-table-column
        v-if="colData[4].istrue"
        width="140"
        prop="basic_info.name"
        label="审批类型">
      </el-table-column>
      <el-table-column
        v-if="colData[5].istrue"
        width="140"
        prop="start_time"
        label="发起时间">
      </el-table-column>
      <el-table-column
        v-if="colData[6].istrue"
        label="状态">
        <template slot-scope="scope">
          <!-- {{scope.row.order_count || '0'}} 个 -->
          <el-tag :type="approvalInstanceStatus.constMap.idMap[scope.row.status].class"
            size="mini">{{approvalInstanceStatus.constMap.idMap[scope.row.status].name}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        v-if="colData[7].istrue"
        prop="properties.title"
        label="审批流标题">
      </el-table-column>
      <el-table-column
        align="right"
        label="操作">
        <template slot-scope="scope">
          <az-button size="mini" type="order"
            content="查看审批详情"
            @click.native="$router.push(`/approval/instance/detail?id=${scope.row.id}&type=${scope.row.basic_info.type}`)">
          </az-button>
          <az-button size="mini" type="record"
            content="打印审批记录"
            @click.native="handlePrint(scope.row.id)">
          </az-button>
          <az-button size="mini" type="spend-money"
            content="打印付款通知单"
            v-if="[3,4,5,6,8, 9, 11].includes(scope.row.basic_info.type) "
            @click.native="handlePrintSpendMoney(scope.row.id)">
          </az-button>
        </template>
      </el-table-column>
      <template slot="empty">
        <az-loading v-if="isLoading"></az-loading>
        <div v-else>暂无数据</div>
      </template>
    </el-table>
    <div class="az-pagination clearfix">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        :page-sizes="[10, 20, 30, 40]"
        @size-change="resetPageGoPage"
        @current-change="goPage"
        :current-page.sync="pageInfo.page"
        :page-size.sync="pageInfo.per_page"
        :total="total"></el-pagination>
    </div>
    <dialog-choose-approval ref="chooseApprovalBar"
      @choose="chooseInstanceType">
    </dialog-choose-approval>
    <ad-apply-spend-money ref="adApplySpendMoney" @refresh="renderList">
    </ad-apply-spend-money>
    <applay-reimbursement ref="applayReimbursement" @refresh="renderList">
    </applay-reimbursement>
    <pd-apply-spend-money ref="pdApplySpendMoney" @refresh="renderList">
    </pd-apply-spend-money>
    <cost-apply-spend-money ref="costApplySpendMoney" @refresh="renderList">
    </cost-apply-spend-money>
    <earnest-apply-spend-money ref="earnestApplySpendMoney" @refresh="renderList">
    </earnest-apply-spend-money>
    <fixed-apply-spend-money ref="fixedApplySpendMoney" @refresh="renderList">
    </fixed-apply-spend-money>
    <applay-reserve-funds ref="applayReserveFunds" @refresh="renderList">
    </applay-reserve-funds>
    <tax-apply-spend-money ref="taxApplySpendMoney" @refresh="renderList">
    </tax-apply-spend-money>
    <confirm-cost ref="confirmCost" @refresh="renderList"></confirm-cost>
    <client-refund ref="clientRefund" @refresh="renderList"></client-refund>
    <inside-transfer-money ref="insideTransferMoney" @refresh="renderList">
    </inside-transfer-money>
  </div>
</template>
<script>
import azButton from '@/base/azButton.vue';
import azSearch from '@/base/azSearch.vue';
// import orgCardDialog from './orgCardDialog';
import { openConfirmModal } from '@/base/azConfirm/index.js';
// import { getOrgList, deleteOrg } from '@/api/org-manage';
import { CancelToken } from 'axios';
// import { extract422Message } from '@/utils/utils';
import dayjs from 'dayjs';
import { approvalTypes, approvalInstanceStatus, approvalInstanceType, statusList } from '@/const'
import dialogChooseApproval from './dialogChooseApproval'
import { getApprovalInstances } from '@/api/approval'
import { getUsers } from '@/api/user'
import { formatNum } from '@/utils/toTx'
import adApplySpendMoney from './instanceForm/adApplySpendMoney'
import pdApplySpendMoney from './instanceForm/pdApplySpendMoney'
import costApplySpendMoney from './instanceForm/costApplySpendMoney'
import fixedApplySpendMoney from './instanceForm/fixedApplySpendMoney'
import applayReimbursement from './instanceForm/applayReimbursement'
import applayReserveFunds from './instanceForm/applayReserveFunds'
import confirmCost from './instanceForm/confirmCost'
import earnestApplySpendMoney from './instanceForm/earnestApplySpendMoney'
import clientRefund from './instanceForm/clientRefund'
import taxApplySpendMoney from './instanceForm/taxApplySpendMoney'
import insideTransferMoney from './instanceForm/insideTransferMoney.vue'
import printMethodsMinix from './printDateMethods'
export default {
  name: 'approvalList',
  components: {
    azButton,
    azSearch,
    dialogChooseApproval,
    applayReserveFunds,
    adApplySpendMoney,
    pdApplySpendMoney,
    costApplySpendMoney,
    fixedApplySpendMoney,
    applayReimbursement,
    confirmCost,
    earnestApplySpendMoney,
    clientRefund,
    taxApplySpendMoney,
    insideTransferMoney

  },
  mixins: [printMethodsMinix],
  watch: {
    checkedColumns(val) {
      let arr = this.checkBoxGroup.filter(i => !val.includes(i));
      this.colData.forEach(i => {
        if (arr.indexOf(i.title) != -1) {
          i.istrue = false;
        } else {
          i.istrue = true;
        }
      });
      localStorage.setItem('checkedColumns', JSON.stringify(this.checkedColumns))
      localStorage.setItem('colData', JSON.stringify(this.colData))
      this.reload = Math.random()
    }
  },
  computed: {
    selectUserShow() {
      return this.$route.params.type != 3
    },
    instanceFormType() {
      if (this.instanceInfo.basic_info) {
        const mapItem =
          this.approvalInstanceType.constMap.idMap[
          this.instanceInfo.basic_info.type
          ];
        return mapItem.enName;
      } else {
        return '';
      }
    },
  },

  created() {
    this.tabActiveId = `${this.$route.params.type}`
    this.initParams(this.$route);
    this.getSelectUserList()
    this.renderList();
    const colData = JSON.parse(localStorage.getItem('colData'));
    const checkedColumns = JSON.parse(localStorage.getItem('checkedColumns'))
    console.log(colData, 'colData')
    if (colData) {
      this.colData = colData;
    }
    if (checkedColumns) {
      this.checkedColumns = checkedColumns;
    }
  },
  data() {
    return {
      reload: Math.random(), // table闪烁问题
      colData: [
        { title: '标题', istrue: true },
        { title: '记录编号', istrue: true },
        { title: '发起人', istrue: true },
        { title: '金额', istrue: true },
        { title: '审批类型', istrue: true },
        { title: '发起时间', istrue: true },
        { title: '状态', istrue: true },
        { title: '审批流标题', istrue: true },
      ],
      // 多选框的列表，列出表格的每一列
      checkBoxGroup: ['标题', '记录编号', '发起人', '金额', '审批类型', '发起时间', '状态', '审批流标题'],
      // 当前选中的多选框，代表当前展示的列
      checkedColumns: ['标题', '记录编号', '发起人', '金额', '审批类型', '发起时间', '状态', '审批流标题'],

      approvalInstanceType,
      type: this.$route.params.type,
      statusList,
      tableList: [{
        basic_info: {
          name: '报销',
          type: 1,
          version: ''
        },
        start_time: '2020-10-10 10:00:00',
        serial_number: '123abs-dsafa',
        department_id: '',
        status: 1,
        promoter: '张三'
      }],
      options: [],
      checkeds: [],
      isLoading: true,
      cancel: null,
      keyword: '',
      total: 0,
      approvalTypes,
      approvalInstanceStatus,
      tabActiveId: '',
      userList: [],
      pageInfo: {
        page: 1,
        per_page: 10,
        user_open_id: this.$route.params.user_open_id, // 筛选用户
        task_type: this.$route.params.type, // 1待办 2已办 3已发起
        basic_type: this.$route.params.basic_type || '', //  1报销 2备用金(个人借款) , 3用款申请（行政,人力,财务)4用款申请（采购）
        status: this.$route.params.status || '', // 1审批中2.通过，3拒绝4撤回5删除
        keyword: this.$route.params.keyword || ''
      },
      groupList: [{
        id: '',
        name: '所有分组'
      }],
      instanceInfo: {} // 实例基本信息
    }
  },
  methods: {
    clearPageInfo() {
      this.pageInfo = {
        ...this.pageInfo,
        status: '',
        keyword: '',
        basic_type: '',
        user_open_id: ''
      }
      this.$refs['azSearch'].$emit('clear');
      console.log(this.pageInfo, 'pageinfo')
      this.pageUpdate()
    },
    async handlePrint(id) {
      try {
        await this.initPage(id);
        console.log(this.instanceInfo, '000000000000000')
        const { form } = this.instanceInfo;
        let printFileData = {
          instanceFormType: this.instanceFormType,
        };
        const commonData = this.handleCommon();
        if (this.instanceFormType == 'applayReimbursement') {
          // 1.报销
          let reimbursement = this.handleReimbursement(form);
          printFileData = {
            ...printFileData,
            ...commonData,
            ...reimbursement,
          };
        } else if (
          [
            'adApplySpendMoney',
            'pdApplySpendMoney',
            'costApplySpendMoney',
            'fixedApplySpendMoney',
            'earnestApplySpendMoney',
            'clientRefund',
            'taxApplySpendMoney',
            'insideTransferMoney',
          ].includes(this.instanceFormType)
        ) {
          // 用款申请
          let applySpendMoney = this.handleApplySpendMoney(form);
          printFileData = {
            ...printFileData,
            ...commonData,
            ...applySpendMoney,
          };
        } else if (this.instanceFormType === 'applayReserveFunds') {
          // 备用金
          let applayReserveFunds = this.handleApplayReserveFunds(form);
          printFileData = {
            ...printFileData,
            ...commonData,
            ...applayReserveFunds,
          };
        } else if (this.instanceFormType === 'confirmCost') {
          // 备用金
          let confirmCost = this.handleConfirmCost(form);
          printFileData = {
            ...printFileData,
            ...commonData,
            ...confirmCost,
          };
        }
        sessionStorage.setItem('ag-print', JSON.stringify(printFileData));
        // this.$router.push('/approval/instance/print');
        window.open('/approval/instance/print-record', '_blank');
      } catch (err) {
        console.log(err)
        this.$message.error(err.response && err.response.data ? err.response.data.message : err.message)
      }

    },
    async handlePrintSpendMoney(id) {
      await this.initSpendMoney(id);
      this.dealSpendMoneyData()
      window.open('/approval/instance/print-money', '_blank');
      // this.$router.push('/approval/instance/print-spend-money');
    },
    // 跳转路由
    pageUpdate() {
      let query = {
        ...this.pageInfo,
      };
      this.$router.push({
        path: this.$route.path,
        query
      });
    },
    selectHandler() {
      this.pageInfo.page = 1;
      this.pageUpdate()
    },
    chooseInstanceType(typeId) {
      const typeItem = this.approvalInstanceType.constMap.idMap[typeId] || {}
      console.log(typeItem, 'typeItem');
      console.log(this.approvalInstanceType, 'approvalInstanceType');
      this.$refs[typeItem.enName].$emit('open', typeId)
    },

    tabChangeHandler() {
      this.$router.push(`/approval/instance/list/${this.tabActiveId}`)
    },
    resetPageGoPage() {
      this.pageInfo.page = 1;
      this.goPage();
    },
    handleSelectionChange(checkeds) {
      this.checkeds = checkeds;
    },
    editHandler(row) {
      this.$refs['orgCardDialogRef'].$emit('edit', row.id);
    },
    toCancel() {
      console.log('this.cancel', this.cancel)
      if (this.cancel) {
        this.cancel();
      }
    },

    initParams(route) {

      console.log(route.params, route.query, 'route')
      this.pageInfo.page = route.query.page - 0 || 1;
      this.pageInfo.per_page = route.query.per_page - 0 || 10;
      this.pageInfo.task_type = route.params.type;
      this.pageInfo.basic_type = route.query.basic_type;
      this.pageInfo.keyword = route.query.keyword;
      this.pageInfo.status = route.query.status - 0 || '';
    },

    renderList() {
      this.tableList = [];
      this.isLoading = true;
      this.toCancel();
      getApprovalInstances({
        ...this.pageInfo,
        _v: dayjs().valueOf()
      }, new CancelToken(c => (this.cancel = c))).then(res => {
        if (res.code != 0 || !res.data || !Array.isArray(res.data.items)) return
        const items = res.data.items || []
        this.tableList = items.map(item => {
          let obj = item.instance_info;
          obj.properties = item.basic_node_info.properties;
          obj.process_data.format_sum_money = formatNum(obj.process_data.sum_money)
          return obj;
        })
        console.log('res.data.items', res.data.items)
        this.total = res.data?.total || 0;
      }).catch(err => {
        /** 注释 */
      }).finally(err => {
        this.isLoading = false;
      })

    },
    goPage() {
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.pageInfo,
          __: dayjs().valueOf()
        }
      });
    },
    handleModify(row) {
      this.$refs['orgCardDialogRef'].$emit('edit');
    },
    searchHandler(val) {
      this.pageInfo.keyword = val;
      this.resetPageGoPage();
    },
    deleteHandler(orgId) {
      const beforeClose = (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '删除中...';
          // deleteOrg(orgId).then(res => {
          //   if (res.code === 422) throw new Error(extract422Message(res.data));
          //   if (res.code != 0) throw new Error(res.message);
          //   this.dialogVisible = false;
          //   this.$message.success('app用户删除成功~！');
          //   done();
          //   this.renderList();
          // }).catch(err => {
          //   this.$message.error(err.response && err.response.data ? err.response.data.message : err.message);
          // }).finally(() => {
          //   instance.confirmButtonLoading = false;
          // })
        } else {
          done();
        }
      };

      openConfirmModal(this, {
        title: '删除提示',
        txt: '确认要删除所选机构吗？',
        type: 'danger',
        beforeClose: beforeClose
      }).then(action => {
        console.log('1')
      }).catch(err => {
        console.log(err);
      }).finally(() => {
      });
    },
    getSelectUserList() {
      getUsers().then(res => {
        if (res.code != 0) {
          return this.$message({ type: 'error', message: '获取搜索用户列表失败' })
        }
        this.userList = res.data;
      })
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.initParams(to);
    this.tabActiveId = `${to.params.type}`
    this.renderList();
    next();
  },

}
</script>
